import styled from 'styled-components';

const MainNavLinks = styled.div`
  margin: 0 auto;
  pointer-events: none;
`;

export default MainNavLinks;
